import { render } from "./MPhoneNumber.vue?vue&type=template&id=0b12af4e&scoped=true"
import script from "./MPhoneNumber.vue?vue&type=script&lang=js"
export * from "./MPhoneNumber.vue?vue&type=script&lang=js"

import "./MPhoneNumber.vue?vue&type=style&index=0&id=0b12af4e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b12af4e"]])

export default __exports__